"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const common_1 = require("@bimser/common");
function init() {
    return window.serviceConfig ? window.serviceConfig.services : null;
}
const Services = common_1.HTTPRequest.createInstances(init());
exports.default = Services;
//# sourceMappingURL=services.js.map